import { firstValueFrom, from } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

angular.module("EICDataStream3.userData", [])
  .service("userAccessService",
    [
      "$http", "$window", function ($http, $window) {
        var service = this;
        var rights$ = null;
        var fullDetails$ = null;

        var getRightsStream = function () {
          if (!rights$) {
            rights$ = from($http.get("/api/currentUserAccessRights"))
              .pipe(shareReplay(1));
          }

          return rights$;
        };

        var getFullDetailsStream = function () {
          if (!fullDetails$) {
            fullDetails$ = from($http.get('/api/currentuser/fulldetails'))
              .pipe(shareReplay(1));
          }

          return fullDetails$;
        };

        service.getRights = function (options) {
          if (options && options.timeout) {
            return $http.get('/api/currentUserAccessRights', { timeout: options.timeout });
          }

          return firstValueFrom(getRightsStream());
        };

        service.getFullDetails = function (options) {
          if (options && options.timeout) {
            return $http.get('/api/currentuser/fulldetails', { timeout: options.timeout });
          }

          return firstValueFrom(getFullDetailsStream());
        };

        service.invalidateCache = function () {
          rights$ = null;
          fullDetails$ = null;
        };

        $window.addEventListener('ds-auth-changed', service.invalidateCache);


      }
    ]);